import { IContainer } from '../../interface/container';
import { injectFetch } from '../../interface/util';
import { injectConfigAPI } from '../../interface/config';
import { injectProgressPromise } from '../../interface/promise';
import mediaImpl from './media';

function media(container: IContainer) {
    const promiser = injectProgressPromise(container);
    const fetcher = injectFetch(container);
    const config = injectConfigAPI(container);

    const module = {
        requestURL: (mediaId: string) => mediaImpl.requestURL(config, mediaId),
        getMedia: (authToken: string, mediaId: string) =>
            mediaImpl.getMedia(promiser, config, fetcher, 'blob', authToken, mediaId),
        getMediaNoResponse: (authToken: string, mediaId: string) =>
            mediaImpl.getMedia(promiser, config, fetcher, 'none', authToken, mediaId),
    };

    return module;
}

export default media;
